import * as React from 'react';
import { Detector } from 'react-detect-offline';
import { message, notification } from 'antd';
import injectSheet from 'react-jss';
import { API_BASE_URL } from 'src/globals';
import { StyleProps } from 'src/Library/Types';

const styles = (theme) => ({
  message: {
    backgroundColor: 'green',
    color: 'white',
    '& .ant-notification-notice-message': {
      color: 'white',
    },
    '& .ant-notification-notice-icon': {
      color: 'white',
    },
    '& .ant-notification-notice-close': {
      color: 'white',
    },
  },
});

interface PropTypes extends StyleProps<typeof styles> {}

class OnlineDetector extends React.PureComponent<
  PropTypes,
  { isOnline: boolean; offlineMessage: string; onlineMessage: string }
> {
  state = {
    isOnline: true,
    offlineMessage: 'You are currently offline.',
    onlineMessage: 'Connected',
  };

  pollingOptions = {
    enabled: true,
    url: `${API_BASE_URL}/`,
    interval: 60 * 1000,
    timeout: 5 * 1000,
  };

  componentDidMount(): void {
    window.addEventListener('online', (e) => {
      this.setState({
        isOnline: true,
      });
    });
    window.addEventListener('offline', (e) => {
      this.setState({
        isOnline: false,
      });
    });
  }

  componentDidUpdate(
    prevProps: Readonly<PropTypes>,
    prevState: Readonly<{ isOnline: boolean }>,
    snapshot?: any
  ): void {
    const { isOnline } = this.state;

    if (prevState.isOnline !== isOnline) {
      this.handleNetworkNotification(isOnline);
    }
  }

  handleNetworkNotification = (isOnline: boolean) => {
    const { classes } = this.props;
    notification.close(`online_${isOnline ? false : true}`);

    if (isOnline) {
      notification.success({
        key: `online_${isOnline}`,
        message: this.state.onlineMessage,
        placement: 'bottomLeft',
        className: classes.message,
      });
    } else {
      notification.error({
        key: `online_${isOnline}`,
        duration: 0,
        placement: 'bottomLeft',
        className: classes.message,
        style: { backgroundColor: 'red', color: 'white' },
        message: this.state.offlineMessage,
      });
    }
  };

  render() {
    return <></>;
  }
}

const OnlineDetectorStyled = injectSheet(styles)(OnlineDetector);
export default OnlineDetectorStyled;
